// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

// De voortgangsbalk verschijnt standaard pas na een halve seconde. Precies in
// dat gat zat het gevoel dat er niets gebeurde: een scherm van deze app kost
// de server 200 tot 1000 ms, dus je tikte en zag niets gebeuren.
Turbo.setProgressBarDelay(100)

// De servicewerker maakt de app installeerbaar op een telefoon.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker").catch(() => {})
  })
}
